import React, { Suspense, useContext } from 'react';
import './myViewsPage.css';
import AppContext from 'contexts/appContext';
import AllViews from './mainSections/allViews';
import Settings from './mainSections/settings';
import { useTranslation } from 'react-i18next';

function Page(props) {
  const { appState, setMyViewsSection } = useContext(AppContext);
  const { t } = useTranslation();

  const changeMainSection = (section) => {
    setMyViewsSection(section);
  }

  return (
    <>
      <div id='mainContainer' className={'container-fluid ' + appState.theme}>
        <div className='row'>
          <div className='col-sm-3 col-md-2 sidemenu sidemenu-left '>
            <div>
              <div className='sidemenu-group'>
                <div className='sidemenu-title'>
                  {t('LIVE')}
                </div>
                <div className='sidemenu-body'>
                  <ul className='nav nav-sidemenu'>
                    <li className='nav-sidemenu-parent'>
                      <a href='#'>{t('QuickViews')} <i className='icons8-expand-arrow pull-right' /></a>
                      {/*
                      <ul className='nav nav-sidemenu nav-sidemenu-child'>
                        <li className=''>
                          <a href='#'>{t('HourlySales')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('HourlyLabor')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('CostCenterSales')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('CategorySales')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('DepartmentLabor')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('Payments')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('ServerSales')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('CheckListing')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('EmployeeListing')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('PunchListing')}</a>
                        </li>
                      </ul>
                    */}
                    </li>
                  </ul>
                  <ul className='nav nav-sidemenu'>
                    <li className={appState.myViewsSection === 'AllViews' ? 'nav-sidemenu-parent child-active' : 'nav-sidemenu-parent'}>
                      <a href='#' onClick={() => changeMainSection('AllViews')}>{t('MyViews')} <i className='icons8-expand-arrow pull-right' /></a>
                      {/*
                      <ul className='nav nav-sidemenu nav-sidemenu-child'>
                        <li className='active'>
                          <a href='#'>{t('ALL')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('Summary')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('DailySales')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('DailyLabor')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('Time')}</a>
                        </li>
                        <li className=''>
                          <a href='#'>{t('Safeguard')}</a>
                        </li>
                      </ul>
                    */}
                    </li>
                  </ul>
                  <ul className='nav nav-sidemenu'>
                    <li className='nav-sidemenu-item'>
                      <a href='#'>{t('MyViews')} {t('Setup')}</a>
                    </li>
                  </ul>
                </div>
                <div className='sidemenu-title'>
                  {t('CONFIGURATION')}
                </div>
                <div className='sidemenu-body'>
                  <ul className='nav nav-sidemenu'>
                    <li className={appState.myViewsSection === 'Settings' ? 'nav-sidemenu-parent child-active' : 'nav-sidemenu-parent'}>
                      <a href='#' onClick={() => changeMainSection('Settings')}>{t('Settings')}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-10 offset-lg-2'>
            {SectionToRender(appState.myViewsSection)}
          </div>
        </div>
      </div>
    </>
  );
}

const SectionToRender = (section) => {
  switch (section) {
    case 'AllViews': {
      return <AllViews />;
    }
    case 'Settings': {
      return <Settings />;
    }
    default:
      return <AllViews />;
  }
}

// loading component for suspence fallback
const Loader = () => (
  <div className='App'>
    <div>loading...</div>
  </div>
);

// here app catches the suspense from page in case translations are not yet loaded
export default function MyViewsPage() {
  return (
    <Suspense fallback={<Loader />}>
      <Page />
    </Suspense>
  );
}